"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BitstraysDaoLogicV1Factory = void 0;
const contracts_1 = require("@ethersproject/contracts");
class BitstraysDaoLogicV1Factory extends contracts_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static connect(address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.BitstraysDaoLogicV1Factory = BitstraysDaoLogicV1Factory;
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "NewAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldImplementation",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "NewImplementation",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldPendingAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newPendingAdmin",
                type: "address",
            },
        ],
        name: "NewPendingAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldVetoer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newVetoer",
                type: "address",
            },
        ],
        name: "NewVetoer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "ProposalCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalThreshold",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "quorumVotes",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "ProposalCreatedWithRequirements",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalExecuted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
        ],
        name: "ProposalQueued",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldProposalThresholdBPS",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newProposalThresholdBPS",
                type: "uint256",
            },
        ],
        name: "ProposalThresholdBPSSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalVetoed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldQuorumVotesBPS",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newQuorumVotesBPS",
                type: "uint256",
            },
        ],
        name: "QuorumVotesBPSSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "voter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "votes",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "VoteCast",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldVotingDelay",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newVotingDelay",
                type: "uint256",
            },
        ],
        name: "VotingDelaySet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldVotingPeriod",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newVotingPeriod",
                type: "uint256",
            },
        ],
        name: "VotingPeriodSet",
        type: "event",
    },
    {
        inputs: [],
        name: "BALLOT_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DOMAIN_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_PROPOSAL_THRESHOLD_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_QUORUM_VOTES_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_VOTING_DELAY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_VOTING_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_PROPOSAL_THRESHOLD_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_QUORUM_VOTES_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_VOTING_DELAY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_VOTING_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "_acceptAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "_burnVetoPower",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newPendingAdmin",
                type: "address",
            },
        ],
        name: "_setPendingAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newProposalThresholdBPS",
                type: "uint256",
            },
        ],
        name: "_setProposalThresholdBPS",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newQuorumVotesBPS",
                type: "uint256",
            },
        ],
        name: "_setQuorumVotesBPS",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newVetoer",
                type: "address",
            },
        ],
        name: "_setVetoer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newVotingDelay",
                type: "uint256",
            },
        ],
        name: "_setVotingDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newVotingPeriod",
                type: "uint256",
            },
        ],
        name: "_setVotingPeriod",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bitstrays",
        outputs: [
            {
                internalType: "contract BitstraysTokenLike",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "cancel",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
        ],
        name: "castVote",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "castVoteBySig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "castVoteWithReason",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "execute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "getActions",
        outputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "voter",
                type: "address",
            },
        ],
        name: "getReceipt",
        outputs: [
            {
                components: [
                    {
                        internalType: "bool",
                        name: "hasVoted",
                        type: "bool",
                    },
                    {
                        internalType: "uint8",
                        name: "support",
                        type: "uint8",
                    },
                    {
                        internalType: "uint96",
                        name: "votes",
                        type: "uint96",
                    },
                ],
                internalType: "struct BitstraysDAOStorageV1.Receipt",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "timelock_",
                type: "address",
            },
            {
                internalType: "address",
                name: "bitstrays_",
                type: "address",
            },
            {
                internalType: "address",
                name: "vetoer_",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "votingPeriod_",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "votingDelay_",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "proposalThresholdBPS_",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "quorumVotesBPS_",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "latestProposalIds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalMaxOperations",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalThreshold",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalThresholdBPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "proposals",
        outputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "proposalThreshold",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "quorumVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "forVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "againstVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "abstainVotes",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "canceled",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "vetoed",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "executed",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "propose",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "queue",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "quorumVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "quorumVotesBPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "state",
        outputs: [
            {
                internalType: "enum BitstraysDAOStorageV1.ProposalState",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "timelock",
        outputs: [
            {
                internalType: "contract IBitstraysDAOExecutor",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "veto",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "vetoer",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "votingDelay",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "votingPeriod",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
